<template>
  <div v-if='value' class='notifications-bar layout d-flex'>
    <div class="sidebar d-flex flex-column align-center">
      <div v-if='!notificationsSettingsOpen' class='notifications-content'>
        <div class='notifications-section-headline'>
          <div class='notification-upper-part'>
            <div class="notifications-title">
              {{ $t('notifications.bar.title') }}
            </div>
            <div class='notifications-mark-all-btn'>
              <v-btn text @click='markAllAsRead'> {{ $t('notifications.mark.all.as.read') }} </v-btn>
            </div>
          </div>
          <div v-if='!isServiceProvider' class='notifications-filter-checkbox'>
            <div class='checkbox-filter-option'>
              <custom-checkbox
                color="cold-marine"
                v-model="scansFilterValue"
                :title='notificationsFilterOptions[notificationTypes.SCANS]'
              />
            </div>
<!-- bugfix/CYN-1789-multiple-ui-currections, remove pt project from notifications -->
<!--            <div class='checkbox-filter-option'>-->
<!--              <custom-checkbox-->
<!--                color="cold-marine"-->
<!--                v-model="ptProjectsValue"-->
<!--                :title='notificationsFilterOptions[notificationTypes.PT_PROJECTS]'-->
<!--              />-->
<!--            </div>-->
          </div>
        </div>
        <div class='notifications-list-wrapper'>
          <notifications-list :notifications='notificationsData'/>
        </div>
<!-- bugfix/CYN-1789-multiple-ui-currections, remove settings from notifications -->
<!--        <div class='notifications-settings-btn-section' @click='toggleNotificationsSettingsWindow'>-->
<!--        <span class='notifications-settings-btn'>-->
<!--          <span class="material-icons">-->
<!--            settings-->
<!--          </span>-->
<!--          <span class='notifications-settings-btn-txt'>-->
<!--            {{ $t('notifications.settings.btn') }}-->
<!--          </span>-->
<!--        </span>-->
<!--        </div>-->
      </div>
      <div v-else class='notifications-settings-wrapper' >
        <notifications-settings
          @toggleNotificationsSettingsWindow='toggleNotificationsSettingsWindow'
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import CustomCheckbox from '@/components/common/CustomCheckbox.vue';
import NotificationsList from '@/components/notifications/NotificationsList.vue';
import { UPDATE_NOTIFICATION_STATUS } from '@/store/notification/actionTypes';
import NotificationsSettings from '@/components/notifications/NotificationsSettings.vue';
import { NotificationTypes, ptProjectFilterMessageTypes, ScansFilterMessageTypes } from '@/constants/notifications';

export default {
  name: 'NotificationsLayout',
  props: {
    value: {
      default: false,
      required: true,
    },
  },
  data() {
    return {
      polling: null,
      notificationsSettingsOpen: false,
      scansFilterValue: false,
      ptProjectsValue: false,
    };
  },
  components: {
    CustomCheckbox,
    NotificationsList,
    NotificationsSettings,
  },
  computed: {
    ...mapGetters(['notifications', 'isServiceProvider']),
    notificationsData() {
      let notificationsData = [];
      if ((this.scansFilterValue && this.ptProjectsValue) || (!this.scansFilterValue && !this.ptProjectsValue)) {
        notificationsData = this.notifications;
      } else if (this.scansFilterValue) {
        this.notifications.forEach(notification => {
          if (notification.metaData?.notificationType && ScansFilterMessageTypes.includes(notification.metaData.notificationType)) {
            notificationsData.push(notification);
          }
        });
      } else if (this.ptProjectsValue) {
        this.notifications.forEach(notification => {
          if (notification.metaData?.notificationType && ptProjectFilterMessageTypes.includes(notification.metaData.notificationType)) {
            notificationsData.push(notification);
          }
        });
      }
      return notificationsData;
    },
    notificationTypes() {
      return NotificationTypes;
    },
    notificationsFilterOptions() {
      return {
        [this.notificationTypes.SCANS]: this.$t('notification.filter.scans.option'),
        [this.notificationTypes.PT_PROJECTS]: this.$t('notifications.filter.project.option'),
      };
    },
  },
  methods: {
    closeNotificationsWindow() {
      this.$emit('closeNotificationsWindow');
    },
    toggleNotificationsSettingsWindow() {
      this.notificationsSettingsOpen = !this.notificationsSettingsOpen;
    },
    async markAllAsRead() {
      const notificationPayload = [];
      this.notifications.forEach(notification => {
        notificationPayload.push(
          {
            ...notification,
            status: 'read',
          },
        );
      });
      await this.$store.dispatch(UPDATE_NOTIFICATION_STATUS, notificationPayload);
    },
  },
};
</script>

<style lang='scss' scoped>
@import "~@/assets/styles/design-system";

.notifications-list-wrapper::-webkit-scrollbar-track {
  background-color: transparent;
}

.notifications-list-wrapper::-webkit-scrollbar-thumb {
  border-radius: $radius-xl;
  -webkit-box-shadow: inset 0 0 $space-2 var(--bg-primary);
}

.checkbox-container {
  .checkmark-title {
    color: var(--text-primary);
  }
}

.transparent-notifications-screen {
  border-radius: $radius-md;
  background-color: var(--bg-primary);
  box-shadow: 0 0 rem(11) 0 rgba(12, 18, 62, 0.13);
  width: 100vh;
  height: 100vh;
}

.notifications-list-wrapper {
  height: calc(100vh);
  overflow-y: auto;
  scrollbar-track-color: transparent;

  ::-webkit-scrollbar-track {
    background-color: transparent;
  }

  ::-webkit-scrollbar-thumb {
    border-radius: $radius-xl;
    -webkit-box-shadow: inset 0 0 $space-2 var(--bg-primary);
  }
}

.notifications-bar {
  border-radius: $radius-sm;
  background-color: var(--bg-primary);
  box-shadow: $space-1 0 $space-5 0 rgba(12, 18, 62, 0.08);
  color: var(--brand-primary);
  font-family: $font-family-regular;
  font-weight: 500;
  font-size: $font-size-base;
  height: 100vh;
  left: $sidebar-width-vw;
  line-height: $line-height-snug;
  padding-bottom: $space-6;
  position: fixed;
  text-align: center;
  top: 0;
  width: rem(382);
  z-index: $z-fixed;
}

.notifications-settings-wrapper {
  height: 100vh;
  width: rem(382);
}

.notifications-content {
  display: flex;
  flex-direction: column;

  .notifications-settings-btn-section {
    box-shadow: 0 -$border-width-thin $space-1 0 rgba(12, 18, 62, 0.08);
    background-color: var(--bg-primary);
    height: $input-height-md;
    width: rem(382);

    .notifications-settings-btn {
      color: var(--brand-primary);
      display: flex;
      margin-top: 2%;

      .notifications-settings-btn-txt {
        margin-right: rem(161);
        flex: 1;
        width: rem(64);
        height: $space-4;
        font-family: $font-family-medium;
        font-size: $font-size-sm;
        font-weight: 500;
        letter-spacing: $letter-spacing-wide;
        line-height: $line-height-tight;
        text-align: center;
      }

      .material-icons {
        flex: 1;
        margin-left: rem(135);
        font-size: $font-size-lg;
        font-weight: bolder;
      }
    }

    &:hover {
      cursor: pointer;
    }
  }

  .notifications-section-headline {
    height: rem(103);
    width: rem(382);
    border-radius: $radius-sm $radius-sm 0 0;
    background-color: var(--bg-secondary);
    box-shadow: 0 0 $space-1 0 rgba(14, 31, 51, 0.13);
    padding-left: $space-5;

    .notifications-filter-checkbox {
      display: flex;
      padding-top: $space-5;
      padding-bottom: $space-3;

      .checkbox-filter-option {
        margin-right: $space-6;

        .custom-checkbox {
          .checkmark-title {
            color: var(--text-primary);
          }
        }

        .checkmark-title {
          color: var(--text-primary);
        }
      }
    }

    .checkmark-title {
      color: var(--text-primary);
    }

    .checkbox-container {
      color: var(--brand-primary);
    }

    .notification-upper-part {
      display: flex;
      align-items: baseline;

      .notifications-title {
        padding-top: $space-8;
        margin-right: rem(82);
        text-transform: uppercase;
        height: $space-4;
        width: rem(116);
        color: var(--text-primary);
        font-family: $font-family-semibold;
        font-size: $font-size-base;
        font-weight: 600;
        letter-spacing: $letter-spacing-wide;
        line-height: $line-height-tight;
      }

      .notifications-mark-all-btn {
        flex: 1;
        float: right;

        .v-btn {
          height: $space-4;
          width: rem(124);
          color: var(--brand-primary);
          font-family: $font-family-medium;
          font-size: $font-size-sm;
          font-weight: 500;
          letter-spacing: $letter-spacing-wide;
          line-height: $line-height-tight;
          text-align: center;
        }
      }
    }
  }
}
</style>
